import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../../../core/design-system/components/Icon';
import './styles.css';

/**
 * Composant qui affiche un message lorsque le profil est restreint
 * @param {Object} props - Les propriétés du composant
 * @param {string} props.type - Le type de restriction ('followers' ou 'private')
 * @returns {JSX.Element} - Le composant
 */
const ProfileRestricted = ({ type = 'private' }) => {
  const { t } = useTranslation('profile');
  
  const isFollowersOnly = type === 'followers';
  
  return (
    <div className="profile-restricted">
      <div className="restricted-icon">
        <Icon name={isFollowersOnly ? "users" : "lock"} size={48} />
      </div>
      
      <h2 className="restricted-title">
        {isFollowersOnly
          ? t('restricted.followers_only.title')
          : t('restricted.private.title')}
      </h2>
      
      <p className="restricted-message">
        {isFollowersOnly
          ? t('restricted.followers_only.message')
          : t('restricted.private.message')}
      </p>
    </div>
  );
};

export default ProfileRestricted; 